import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { RealtimeHubService, HubEventRegistration } from '../shared/services/realtime-hub.service';
import { WorkerChangeTypeEnum } from '../models/enums/worker-change-type-enum';

export interface WorkersInvalidatedEvent {
  WorkerId: number | null;
  InstitutionId: number | null;
  ChangeType: WorkerChangeTypeEnum;
}

/**
 * SignalR service for workers list real-time invalidation.
 * Extends the generic RealtimeHubService with workers-specific event.
 *
 * Note: The .NET backend sends anonymous objects which System.Text.Json
 * serializes using camelCase. We map them back to PascalCase to stay
 * consistent with the rest of the frontend DTO conventions.
 */
@Injectable({ providedIn: 'root' })
export class WorkersSignalrService extends RealtimeHubService {
  private readonly invalidatedSubject = new Subject<any>();

  /** Emits each time the backend sends a WorkersInvalidated event (mapped to PascalCase) */
  readonly invalidated$ = this.invalidatedSubject.asObservable().pipe(
    map((raw: any) => ({
      WorkerId: raw.workerId ?? null,
      InstitutionId: raw.institutionId ?? null,
      ChangeType: raw.changeType ?? 0,
    } as WorkersInvalidatedEvent)),
  );

  protected readonly hubPath = 'workershub';

  protected readonly eventRegistrations: HubEventRegistration[] = [
    { eventName: 'WorkersInvalidated', subject: this.invalidatedSubject },
  ];
}
